<div class="input-group recherche {{id}}" dropdown [autoClose]="true" [isOpen]="status.isopen" (blur)="toggleDropdown"
    [ngClass]="{'recherchetoogle': status.isopen, 'disabledbutton': disableRecherche}" (click)="focusInput()"
    [id]="prefixid + '_contentMultiple'">
    <div style="display: inline-flex;overflow-x: hidden;"
        [ngStyle]="{'width': listeFiltre && listeFiltre.length ? 'calc(100% - 54px)' : 'calc(100% - 48px)'}">
        <div class="choix" [ngClass]="{'choixEcoportail': isSearchEcoportail}"
            *ngFor="let elt of listeFiltre; let i=index;">
            <div style="overflow: hidden; white-space: nowrap; height: 16px;" [innerHTML]="elt.libelleObjetEntite">
            </div>
            <img src="assets/images/icons/removeblanc.svg" class="icon-exit" alt="icon_search"
                (click)="deleteFilter(i, elt)">

            <!-- <i class="fa fa-times pull-right" aria-hidden="true" ></i> -->
        </div>
        <form autocomplete="off" style="width: 100%;">
            <input *ngIf="!isSearchEcoportail" type="text" [(ngModel)]="search" id="searchElem" class="form-control"
                [placeholder]="placeholder" name="search" (ngModelChange)="searchelement($event)"
                (keydown)="defaultFocus($event)" [disabled]="disableFocusAuto" (keyup.enter)="valideChoice(selected)"
                autocomplete="off" autofill="off" />
            <input *ngIf="isSearchEcoportail" type="text" [(ngModel)]="search" id="searchElem" class="form-control"
                [placeholder]="placeholder" name="search" (ngModelChange)="searchelement($event)"
                style="color: #000 !important;" (keydown)="defaultFocus($event)" (keyup.enter)="valideChoice(selected)"
                autocomplete="off" autofill="off" />
        </form>

        <!-- [attr.style]="('color:' + (isSearchEcoportail ? '#000' : 'rgba(55, 97, 148, 0.6)') + '!important') | safeStyle"-->
    </div>

    <div class="input-group-addon" [ngStyle]="{'right': listeFiltre.length ? '30px' : '2px'}" style="cursor: pointer;">
        <img src="assets/images/icons/search.svg" class="pull-right" [id]="prefixid + '_btnsearch'" alt="search"
            *ngIf="!isSearchEcoportail" (click)="searchByBtn($event)" />
        <app-icons-ecoportail [icon]="'search'" [couleur]="disableRecherche ? '#c0c0c0' : user.couleur"
            [id]="prefixid + '_btnsearch'" *ngIf="isSearchEcoportail"
            (click)="searchByBtn($event)"></app-icons-ecoportail>
    </div>
    <div class="input-group-addon" *ngIf="listeFiltre.length" [id]="prefixid + '_remove'" (click)="removeFilter()"
        style="padding-top: 8px;">

        <img src="assets/images/icons/remove.svg" class=" remove-icon" alt="search" *ngIf="!isSearchEcoportail" />
        <app-icons-ecoportail [icon]="'remove'" class=" remove-icon"
            [couleur]="disableRecherche ? '#c0c0c0' : user.couleur" *ngIf="isSearchEcoportail">
        </app-icons-ecoportail>
    </div>
    <ul *dropdownMenu style="border-radius:none ! important;" [id]="prefixid + '_ul'" class="dropdown-menu" id="menu"
        role="menu">
        <mat-progress-bar *ngIf="isLoading" style="margin-top: -5px;" mode="indeterminate"></mat-progress-bar>
        <li role="menuitem" *ngFor="let item of results; let i = index" tabindex="{{i}}" [id]="prefixid + '_li'"
            (keydown)="changeFocus($event, i)" (keyup.enter)="addFilter(item)" (click)="addFilter(item)"
            [ngClass]="{'selected' : selected && selected.id === item.id}" style="outline:none;">
            <a class="dropdown-item col-sm-12" [ngClass]="{'selected' : selected && selected.id === item.id}"
                [id]="prefixid + '_a'" style="padding: 0; white-space: normal;">
                <!--a class="dropdown-item col-sm-12" style="height:25px;"-->
                <div class="col-sm-4"> {{ item.type }} </div>
                <div class="col-sm-8" [innerHTML]="item.libelleObjetEntite | highlight:search"></div>
            </a>
        </li>
        <li role="menuitem" *ngIf="!results.length  && !isLoading" [id]="prefixid + '_nomatch'"><a class="dropdown-item"
                [id]="prefixid + '_nomatcha'">Pas de correspondance</a>
        </li>
        <li role="menuitem" *ngIf="!results.length && isLoading" [id]="prefixid + '_load'"><a class="dropdown-item"
                [id]="prefixid + '_loada'">En cours de recherche... </a>
        </li>
        <li role="menuitem" *ngIf="results.length && isMessagePreciserRecherche" [id]="prefixid + '_plusresultat'"><a
                class="dropdown-item text-center" [id]="prefixid + '_plusresultat'" style="white-space: normal;font-weight: 600;">Pour voir plus de résultat veuillez
                préciser votre recherche en ajoutant des caractères </a>
        </li>
    </ul>
</div>


<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> {{ error }} </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
        </div>
    </div>
</ng-template>